import script from "./Related.vue?vue&type=script&setup=true&lang=ts"
export * from "./Related.vue?vue&type=script&setup=true&lang=ts"

import "./Related.vue?vue&type=style&index=0&id=6a746eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a746eba"]])

export default __exports__